import { FC } from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';

import { itemIdMatch } from '~src/constants';
import PageNotFound from '~src/shared/errorPages/PageNotFound';
import { routes } from '~src/routingConfig';

import ObjectivesOverview from './objectivesOverview/ObjectivesOverview';
import ObjectiveAdd from './manageObjectives/create/ObjectiveAdd';
import ObjectiveDetails from './manageObjectives/edit/ObjectiveDetails';
import ObjectivesRouterSuper from './objectivesStream/ObjectivesRouter';

type Props = RouteComponentProps<any>;

const OkrRouter: FC<Props> = props => {
  return (
    <Switch>
      <Route exact strict path={`${props.match.url}/add`} component={ObjectiveAdd} />
      <Route
        path={routes.okrs.objectiveDetails(`:objectiveId(${itemIdMatch})`)}
        component={ObjectiveDetails}
      />
      <Route path={routes.okrs.objectivesStream.updateObjectiveKRs} component={ObjectivesRouterSuper} />
      <Route path={routes.okrs.objectivesStream.noObjective} component={ObjectivesRouterSuper} />
      <Route exact strict path={props.match.url} component={ObjectivesOverview} />
      {/* todo: add the key-result-stream to the routers.okrs.stream,
      but first need to extract all objectives */}
      <PageNotFound {...props} />
    </Switch>
  );
};

const OkrRouterWithRouter = withRouter(OkrRouter);
export default OkrRouterWithRouter;
